// ============================================
// ゲームエンティティ状態管理
// ============================================

import { PlayerStateMachine } from '../features/player/states/player-machine';
import { InactiveState } from '../features/player/states/player-states';
import type {
    Player,
    Bullet,
    EnemyBullet,
    Enemy,
    Item,
    Particle,
    BgStar,
    Lane
} from '../types/game-types';

// --- ゲームオブジェクト配列 ---
export const player: Player = {
    active: false,
    x: 0,
    y: 0,
    lane: 0,
    targetX: 0,
    size: 0,
    tilt: 0,
    state: null
};

export let bullets: Bullet[] = [];
let _playerStateMachine: PlayerStateMachine | null = null;
export let enemyBullets: EnemyBullet[] = [];
export let enemies: Enemy[] = [];
export let items: Item[] = [];
export let particles: Particle[] = [];
export let stars: BgStar[] = [];

// レーンのX座標を格納する配列
export let lanes: Lane[] = [];

// --- ボス名 ---
let _bossName: string = '';

// ============================================
// Getters and Setters
// ============================================

export const getPlayer = (): Player => player;
export const setPlayer = (p: Player): void => {
    // オブジェクトの参照を置き換えるのではなく、プロパティをコピー
    player.active = p.active;
    player.x = p.x;
    player.y = p.y;
    player.lane = p.lane;
    player.targetX = p.targetX;
    player.size = p.size;
    player.hp = p.hp;
    player.maxHp = p.maxHp;
    player.invincibleTimer = p.invincibleTimer;
    player.flashTimer = p.flashTimer;
    player.tilt = p.tilt;
    player.state = p.state;

    // プレイヤーが新しくなった場合、ステートマシンを初期化する（必要な場合）
    // 通常はゲーム開始時やリセット時に呼ばれる
    if (!_playerStateMachine) {
        _playerStateMachine = new PlayerStateMachine(() => player);
        _playerStateMachine.transitionTo(new InactiveState());
    }
};

export const getPlayerStateMachine = (): PlayerStateMachine => {
    if (!_playerStateMachine) {
        _playerStateMachine = new PlayerStateMachine(() => player);
        _playerStateMachine.transitionTo(new InactiveState());
    }
    return _playerStateMachine;
};

export const getBullets = (): Bullet[] => bullets;
export const setBullets = (b: Bullet[]): void => {
    bullets = b;
};

export const getEnemyBullets = (): EnemyBullet[] => enemyBullets;
export const setEnemyBullets = (b: EnemyBullet[]): void => {
    enemyBullets = b;
};

export const getEnemies = (): Enemy[] => enemies;
export const setEnemies = (e: Enemy[]): void => {
    enemies = e;
};

export const getItems = (): Item[] => items;
export const setItems = (i: Item[]): void => {
    items = i;
};

export const getParticles = (): Particle[] => particles;
export const setParticles = (p: Particle[]): void => {
    particles = p;
};

export const getStars = (): BgStar[] => stars;
export const setStars = (s: BgStar[]): void => {
    stars = s;
};

export const getLanes = (): Lane[] => lanes;
export const setLanes = (l: Lane[]): void => {
    lanes = l;
};

export const getBossName = (): string => _bossName;
export const setBossName = (val: string): void => {
    _bossName = val;
};
